import React from 'react';
import PropTypes from 'prop-types'
import {Button} from '../../commun/button';

export const PlannerBanner = ({label, imgUrl, link, aLabel, eventLabel, eventAction}) => {
    const discoverBannerHandleClick = (eventLabel, eventAction) => {
        appData.actionTrigger.dispatch({
            trigger: "DiscoverBannerPlannerHandleClick",
            payload: {
                eventLabel: eventLabel,
                eventAction: eventAction
            }
        })
    }

    return (
        <div className="bannerContainer">
            <img src={imgUrl} alt="photo de cuisine"/>
            <div className="text">
                <p>{label}<a target='_blank' href={link} onClick={(event) => {
                    discoverBannerHandleClick(eventLabel, eventAction)
                }}>{aLabel}</a></p>
                <Button type="primary" size="medium" enabled callBack={() => {
                    window.open(link, '_blank');
                    discoverBannerHandleClick(eventLabel, eventAction)
                }}
                >
                    Découvrir
                </Button>
            </div>
        </div>
    )
};
PlannerBanner.propTypes = {
    label: PropTypes.string,
    imgUrl: PropTypes.string,
    aLabel: PropTypes.string,
    link: PropTypes.string,
};
PlannerBanner.defaultProps = {
    label: "",
    imgUrl: "",
    aLabel: "",
    link: "",
}